export const imgpathgenerator = (imgname, module) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1);
  // const day = String(now.getDate()).padStart(2, "0");
  // const minute = String(now.getMinutes()).padStart(2, "0");

  const fileExtension = imgname.split(".").pop();
  // const baseName = imgname.replace(/\.[^/.]+$/, "").replace(/\s+/g, '-');

  const baseName = imgname
  .replace(/\.[^/.]+$/, "")         // Remove extension
  .replace(/[^a-zA-Z0-9]+/g, '-')   // Replace non-alphanumeric chars with "-"
  .replace(/^-+|-+$/g, '')          // Trim leading/trailing dashes
  .toLowerCase();
  const timestamp = Date.now();

  return `assets/${module}/${year}/${month}/${encodeURIComponent(
    baseName
  )}_${timestamp}.${fileExtension}`;
  // return `assets/${module}/${year}/${month}/${encodeURIComponent(
  //   baseName
  // )}_${year}${month}${day}_${minute}.${fileExtension}`;
};

export const imgFileNameGenerator = (imgname) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1);
  const day = String(now.getDate()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");

  const fileExtension = imgname.split(".").pop();
  const baseName = imgname.replace(/\.[^/.]+$/, "");

  return `${encodeURIComponent(baseName)}_${year}${month}${day}_${minute}.${fileExtension}`
};

